import { useState } from "react";
import { formatDate } from "../../../utils";
import {
  getFirstDayOfMonth,
  getLastDayOfMonth,
  validateTenantsDates,
} from "../../../utils/dateUtils";
import { generateDownload } from "../../../utils/downloadLink";

const initialDateRange = { from: "", to: "" };

export const useTenantsBillingReports = () => {
  const [pickerDate, setPickerDate] = useState(null);
  const [dateRange, setDateRange] = useState(initialDateRange);
  const [error, setError] = useState(null);
  const [searchParams, setSearchParams] = useState(null);

  const handleChange = (pickedDate) => {
    setPickerDate(pickedDate);
    const parsedPickedDate = {
      from: formatDate(getFirstDayOfMonth(pickedDate), "YYYY-MM-DD"),
      to: formatDate(getLastDayOfMonth(pickedDate), "YYYY-MM-DD"),
    };

    if (
      dateRange.from === parsedPickedDate.from &&
      dateRange.to === parsedPickedDate.to
    ) {
      return null;
    }

    const { queryParams, error: validationError } = validateTenantsDates({
      from: parsedPickedDate.from,
      to: parsedPickedDate.to,
    });

    if (validationError) {
      setError(validationError);
      return null;
    }

    if (error) setError(null);
    setDateRange(parsedPickedDate);
    setSearchParams(queryParams);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!searchParams) {
      setError("something went wrong please try again");
      return null;
    }
    const downloadUrl = `/files/reports/billing-activity-csv${searchParams}`;
    generateDownload(downloadUrl);
  };

  const dateIsPicked = dateRange.from && dateRange.to;

  return {
    dateIsPicked,
    handleChange,
    handleSubmit,
    pickerDate,
    error,
  };
};
